// extracted by mini-css-extract-plugin
export default {"text":"UnsubscribeModal_text__xgXAW","cancel":"UnsubscribeModal_cancel__p8OVi","confirm":"UnsubscribeModal_confirm__MEDLD"};